import classNames from 'classnames'
import styles from './styles.module.scss'

type ISkeletonEllipseProps = {
  size?: number
  className?: string
  animated?: boolean
}

export const SkeletonEllipse = ({ size = 16, className, animated }: ISkeletonEllipseProps) => {
  return (
    <div
      className={classNames(styles.wrap, { [styles.animated]: animated }, className)}
      style={{
        width: size,
        flex: `0 0 ${size}px`,
        height: size,
      }}
    />
  )
}
